import i18n from '../../i18n/i18n';
import { tr } from '../../i18n/i18n';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  createOrganizationService,
  fetchTeacherStudentCountsService,
  organizationService,
  updateOrganizationService,
} from '../../services/organization';
import {
  DataResponse,
  IErrorResponse,
  IMyInstituteReqBody,
  IOrganization,
  IOrganizationReqBody,
  IOrganizationResponse,
} from '../../interface';
import { ICreateSubjectError } from '../../interface/subjectModel';
import axios from 'axios';
import { IEditTeacherProfileRequestBody } from '../../interface/teacherModel';

export const fetchMyOrganization = createAsyncThunk(
  'organization/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const response = await organizationService.fetchMyOrganization();
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data || { message: i18n.t('msg.failed_to_fetch_organization', i18n.t('toast.failed_to_fetch_organization', 'Failed to fetch organization.')) });
    }
  },
);

export const updateMyOrganization = createAsyncThunk(
  'organization/update-institute',
  async ({ body, id }: { body: IMyInstituteReqBody; id: string }, { rejectWithValue }) => {
    try {
      const response = await organizationService.updateMyInstitute(body, id);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err?.message || { message: i18n.t('msg.failed_to_update_organization', 'Failed to update organization.') });
    }
  },
);

export const fetchTeacherStudentCounts = createAsyncThunk<
  DataResponse,
  void,
  { rejectValue: IErrorResponse }
>('organization/fetch-data', async (_, { rejectWithValue }) => {
  try {
    return await fetchTeacherStudentCountsService();
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      return rejectWithValue({
        status: err.response?.status || 500,
        message: err.response?.data?.message || i18n.t('toast.unknown_error', 'Unknown error'),
      });
    }
    return rejectWithValue({ status: err?.status, message: err.message });
  }
});

// 📌 Create organization
export const createOrganization = createAsyncThunk<
  IOrganizationResponse,
  IOrganizationReqBody,
  { rejectValue: IErrorResponse }
>('organization/create', async (body, { rejectWithValue }) => {
  try {
    return await createOrganizationService(body);
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      return rejectWithValue({
        status: err.response?.status || 500,
        message: err.response?.data?.message || i18n.t('toast.unknown_error', 'Unknown error'),
      });
    }
    return rejectWithValue({ status: err?.status, message: err.message });
  }
});

// 📌 Update organization
export const updateOrganization = createAsyncThunk<
  IOrganizationResponse,
  { body: IOrganization; id: string },
  { rejectValue: IErrorResponse }
>('organization/update', async ({ body, id }, { rejectWithValue }) => {
  try {
    return await updateOrganizationService(id, body);
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      return rejectWithValue({
        status: err.response?.status || 500,
        message: err.response?.data?.message || i18n.t('toast.unknown_error', 'Unknown error'),
      });
    }
    return rejectWithValue({ status: err?.status, message: err.message });
  }
});

export const organizationActions = {
  fetchMyOrganization,
  fetchTeacherStudentCounts,
  createOrganization,
  updateOrganization,
  updateMyOrganization,
};
